























































































































































































































import Vue from 'vue';
import { VBToggle, BRow, BCol, BCollapse, BFormInput } from 'bootstrap-vue';
import ZenButton from '@reciprocity/button';
import { debounce } from 'lodash';
import { mapGetters, mapActions } from 'vuex';

import { ZenFormGroup } from 'zenComponents';
import AuditInfoJira from '@/components/jira/components/AuditInfoJira.vue';
import AuditInfoSync from '@/components/ticketing/components/AuditInfoSync.vue';
import DropdownPresenter from '@/components/presenters/DropdownPresenter.vue';
import EditCardDate from '@/components/cards/EditCard/components/EditCardDate.vue';

import StorageIntegration from '../components/storage_integration/StorageIntegration.vue';
import { Audit } from '../types';

export default Vue.extend({
  name: 'ASWStep1',
  components: {
    BCol,
    BRow,
    BFormInput,
    BCollapse,
    ZenFormGroup,
    ZenButton,
    EditCardDate,
    DropdownPresenter,
    AuditInfoJira,
    AuditInfoSync,
    StorageIntegration,
  },
  directives: {
    BToggle: VBToggle,
  },
  props: {
    audit: {
      type: Object as () => Audit,
      required: true,
    },
  },
  data() {
    return {
      isFormDirty: false,
    };
  },
  computed: {
    ...mapGetters({
      apiEndpoints: 'auditSetupWizardApiEndpoints',
      featureFlagState: 'featureFlagState',
    }),
    ...mapGetters('auditSetupWizard', [
      'getAuditStatus',
      'getAuditTypes',
      'getAuditError',
      'getStorageTypes',
      'getJiraBus',
      'getSelectedTicketing',
      'isStorageIntegrationEnabled',
      'getSyncExternalComments',
      'getSyncExternalAttachments',
    ]),
    isEditing(): boolean {
      return !!this.audit.code;
    },
    showTicketingSync(): boolean {
      return !['JIRA', 'ZENGRC'].includes(this.audit.managedIn.value) && this.featureFlagState('new_ticketing');
    },
  },
  created() {
    this.onAuditTitleChangeDebounced = debounce(this.onAuditTitleChange, 500);
  },
  mounted() {
    // TODO: Maybe use something like https://vuelidate.netlify.com to
    // handle form validation, because manually triggering validation
    // and checking if a form is dirty is not ideal.
    this.validateTitle();
    this.validateStorageType();
  },
  methods: {
    ...mapActions('auditSetupWizard', [
      'setAuditTitle',
      'setAuditManagers',
      'setAuditRelatedProgram',
      'setAuditStartDate',
      'setAuditReportStartDate',
      'setAuditReportEndDate',
      'setAuditType',
      'setAuditFirm',
      'setAuditors',
      'setAuditStorageType',
      'setStorageIntegrationData',
      'validateTitle',
      'validateStorageType',
    ]),
    getFormGroupState: function(field: keyof Audit): boolean | null {
      return this.$data.isFormDirty && this.getAuditError(field) ? false : null;
    },
    getFormGroupInvalidFeedback: function(field: keyof Audit): string {
      return this.getAuditError(field);
    },
    onAuditTitleChange: function(value: any): void {
      this.$data.isFormDirty = true;
      this.setAuditTitle(value);
    },
  },
});
